import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
  TextInput,
} from "carbon-components-react";

const EnvironmentalSocialAnalysisForm = ({
  businessPlan,
  disabled,
  register,
  errors,
}) => {
  return (
    <FormGroup
      legendText="6.	SALVAGUARDAS AMBIENTAIS E SOCIAIS"
      className="section-header"
    >
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          6.1.Quais são os potenciais efeitos ambientais negativos dos produtos
          ou serviços que você fornece?.
        </legend>

        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="environmentalEffectDec"
              labelText=""
              rows={7}
              enableCounter
              disabled={disabled}
              {...register("environmentalEffectDec")}
            />
            <p className="field-error">
              {errors.environmentalEffectDec?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mitigationMeasures"
              labelText="6.2 Como pensa em mitigar para os possíveis riscos e impactos identificados?"
              rows={7}
              enableCounter
              disabled={disabled}
              helperText="[Indique as medidas que colocará em prática para minimizar tais riscos e impactos. Use no máximo 200 palavras.]"
              {...register("mitigationMeasures")}
            />
            <p className="field-error">{errors.mitigationMeasures?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          6.3 O seu negócios envolve o uso de terra?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="doesInvolveTheUseOfLand"
              disabled={disabled}
              valueSelected={businessPlan?.doesInvolveTheUseOfLand}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="doesInvolveTheUseOfLand-y"
                {...register("doesInvolveTheUseOfLand")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="doesInvolveTheUseOfLand-n"
                {...register("doesInvolveTheUseOfLand")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.doesInvolveTheUseOfLand?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          6.3.1 Se sim, possui algum título formal de posse de terra?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="hasSomeFormalLandTitle"
              disabled={disabled}
              valueSelected={businessPlan?.hasSomeFormalLandTitle}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="hasSomeFormalLandTitle-y"
                {...register("hasSomeFormalLandTitle")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="hasSomeFormalLandTitle-n"
                {...register("hasSomeFormalLandTitle")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasSomeFormalLandTitle?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={6} lg={6}>
            <TextInput
              id="formalLandTitle"
              labelText="6.3.2 Caso possua algum título formal de posse de terra, especifique abaixo."
              disabled={disabled}
              maxLength={100}
              {...register("formalLandTitle")}
            />
            <p className="field-error">{errors.formalLandTitle?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">6.3.3 O seu título é válido?</legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="isTitleValid"
              disabled={disabled}
              valueSelected={businessPlan?.isTitleValid}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="isTitleValid-y"
                {...register("isTitleValid")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="isTitleValid-n"
                {...register("isTitleValid")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.isTitleValid?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          6.4O seu plano de negócios envolve reabilitações/adequações do espaço
          em que desenvolve o seu negócio?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="doesInvolveRehabilitationOronstruction"
              disabled={disabled}
              valueSelected={
                businessPlan?.doesInvolveRehabilitationOronstruction
              }
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="doesInvolveRehabilitationOronstruction-y"
                {...register("doesInvolveRehabilitationOronstruction")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="doesInvolveRehabilitationOronstruction-n"
                {...register("doesInvolveRehabilitationOronstruction")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.doesInvolveRehabilitationOronstruction?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          6.4.1 Se sim, possui uma licença válida para o efeito?
        </legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="hasValidLicence"
              disabled={disabled}
              valueSelected={businessPlan?.hasValidLicence}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="hasValidLicence-y"
                {...register("hasValidLicence")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="hasValidLicence-n"
                {...register("hasValidLicence")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.hasValidLicence?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

EnvironmentalSocialAnalysisForm.defaultProps = {
  disabled: false,
};
export default EnvironmentalSocialAnalysisForm;
